import { render, staticRenderFns } from "./VideoService.vue?vue&type=template&id=cffcb6dc&scoped=true&"
import script from "./VideoService.vue?vue&type=script&lang=js&"
export * from "./VideoService.vue?vue&type=script&lang=js&"
import style0 from "./VideoService.vue?vue&type=style&index=0&id=cffcb6dc&prod&lang=css&"
import style1 from "./VideoService.vue?vue&type=style&index=1&id=cffcb6dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cffcb6dc",
  null
  
)

export default component.exports